import React from "react";
import { useTranslation } from "react-i18next";
import GoogleAdSense from "../../GoogleAdSense/GoogleAdSense";

const EventsHeading = () => {
  const { t } = useTranslation();
  return (
    <>
      <div className="font-poppins flex justify-center items-center mb-4">
        <h1 className="">{t("Events_For_You")}</h1>
      </div>
      {/* <div style={{ margin: "20px" }}>
        <GoogleAdSense />
      </div> */}
    </>
  );
};

export default EventsHeading;